module.exports = __webpack_public_path__ + "media/images/solutions-analytics-triplet-3-b95aadd533f0a2e046447021b540f730.svg";